import React from "react";
import PropTypes from "prop-types";
import SFIconButton from "../../../button/iconButton";
import { SFCloseIcon } from "../../../icons";
import getStyled from "../../../../hooks/getStyled";

const { styled } = getStyled();

const SFIconButtonStyled = styled(SFIconButton)(({ theme }) => ({
  backgroundColor: theme.palette.grey100.main,
  padding: "2px",
  // The background color should never change
  "&:hover": {
    backgroundColor: theme.palette.grey100.main,
  },
}));

const CloseAction = ({ onClick, disabled }) => {
  return (
    <SFIconButtonStyled onClick={onClick} disabled={disabled}>
      <SFCloseIcon color={!disabled ? "grey500" : "grey300"} size="small" />
    </SFIconButtonStyled>
  );
};

export default CloseAction;

CloseAction.propTypes = {
  // The function to call when the close action is clicked
  onClick: PropTypes.func.isRequired,
};
